import React, {useEffect} from 'react';
import QuestionBuilder from '@ignitesales/react-question-builder';
import { connect } from 'react-redux';
import builderRenderLinkedQuestion from '../../../util/builderRenderLinkedQuestion.mjs';
import {BuilderConnectedPropTypes} from '../../../shapes/index';
import {renderQuestionErrors} from '../../../util/questionUtil.jsx';
import {builderAnswerChanged, builderGroupValidation, builderQuestionValidation} from '../../../actions/question-action-creators';
import Tooltip from '../../Tooltip.jsx';
import {QuestionLayoutContext} from '../QuestionComponentContext';

const BuilderConnected = (props) => {
  const cssBEM = 'builder';
  const {
    attributes,
    builderLinkedQuestions,
    groupKey,
    linkedQuestionValueChanged,
    renderLinkedQuestion,
    rowAdded,
    rowRemoved,
    showAllMode,
    validateBuilder,
    validationErrors = [],
    value,
    ...rest
  } = props;
  const context = React.useContext(QuestionLayoutContext);
  const ErrorTag = attributes?.error?.tag || context?.attributes?.error?.tag;
  const errorProps = attributes?.error?.props || context?.attributes?.error?.props;

  useEffect(() => {
    validateBuilder(currentValues);
  }, []);

  const {
    value: currentValues = []
  } = (value || {});

  const onChange = (rowKey, added) => {
    if (added) {
      rowAdded({
        rowKey,
        currentValues
      });
    } else {
      rowRemoved({
        rowKey,
        currentValues
      });
    }
  };

  const groupErrors = validationErrors.filter(e => e.key === groupKey && e.shouldDisplay);

  const error = () => ErrorTag ?
    <ErrorTag key={`${groupKey}.error`} className={`${cssBEM}__error question__error error`} {...errorProps}>
      {renderQuestionErrors(...groupErrors)}
    </ErrorTag>
    :
    <Tooltip
      type="error"
      key={`${groupKey}.error`}
      className={`${cssBEM}__tooltip error`}
      messageId={groupKey}
      iconRender={<i className="fa fa-exclamation-circle" alt="Error Exclamation Icon" />}
      content={<span>{renderQuestionErrors(...groupErrors)}</span>}
      {...errorProps}
    />;

  const errorNode = groupErrors.length > 0 && groupErrors[0]?.errors && (context?.attributes?.error?.node || error());

  return (
    <>
      {errorNode}
      <QuestionBuilder
        { ...rest }
        checkboxMode={ showAllMode }
        onChange={ onChange }
        renderQuestion={linkedQuestion => builderRenderLinkedQuestion(linkedQuestion, linkedQuestionValueChanged, renderLinkedQuestion)}
        rows={ builderLinkedQuestions }
        values={ currentValues }
      />
    </>
  );
};

BuilderConnected.propTypes = {
  ...BuilderConnectedPropTypes
};

export default connect(
  ({ answers, validationErrors }, { questionGroup: { attributes }}) => {
    const value = answers[attributes.questionGroupKey];
    return {
      groupKey: attributes?.questionGroupKey,
      value,
      validationErrors
    };
  },
  (dispatch, { questionGroup, builderOptions: question }) => {
    return {
      rowAdded: ({ rowKey, currentValues }) => {
        const value = [ ...currentValues, rowKey ];
        dispatch( builderAnswerChanged({ question, questionGroup, value }) );
      },
      rowRemoved: ({ rowKey, currentValues }) => {
        const value = currentValues.filter(v => v !== rowKey);
        dispatch( builderAnswerChanged({ question, questionGroup, value, hasBeenRemoved: rowKey }) );
      },
      linkedQuestionValueChanged: linkedQuestion => {
        dispatch( builderQuestionValidation({linkedQuestion, questionGroup, shouldDisplay: true}) );
      },
      validateBuilder: value => {
        dispatch( builderGroupValidation({questionGroup, question, value}) );
      }
    };
  }
)(BuilderConnected);
